var _g;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgService = function SvgService(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.498 15.996 3.425 1.141s8.562-1.712 9.704-1.712 1.141 1.142 0 2.283c-1.142 1.142-5.138 4.567-8.562 4.567-3.425 0-5.708-1.713-7.991-1.713H.366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.366 13.712c1.141-1.141 3.424-2.854 5.708-2.854 2.283 0 7.705 2.283 8.562 3.425.856 1.141-1.713 2.854-1.713 2.854M7.215 7.434V2.867c0-.63.511-1.141 1.142-1.141h13.699c.63 0 1.141.511 1.141 1.141V12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.353 1.726h5.708v5.137h-5.708z"
  }))));
};
export default SvgService;